<template>
    <div>
        <b-sidebar
            v-if="isSideBarOpenDriverLocal"
            v-model="isSideBarOpenDriverLocal"
            id="sidebar-right"
            title="Добавление ТС"
            right
            backdrop
            shadow
            width="65em"
            backdrop-variant="dark"
            no-close-on-backdrop
            @change="closeSidePanelCallback()"
        >
            <div class="d-block">
                <div class="form-group">
                    <label for="companies">Выберите компанию, к которой будет прикреплено ТС</label>
                    <div class="row px-0">
                        <div class="col-11">
                            <tsoft-select-company
                                :needNullElement="true"
                                @set="setCompanyOfTruck"
                            ></tsoft-select-company>
                        </div>
                        <div class="col-1">
                            <b-button
                                :disabled="(selectedCompanyId != '') ? false:true"
                                size="lg"
                                class="big-add-button"
                                variant="success"
                                title="Добавить"
                                @click="addCompanyToList()"
                            ><b-icon icon="plus" font-scale="1.2"></b-icon></b-button>
                        </div>
                    </div>
                    <template v-if="editedItem.companies.length > 0">
                        <div class="mt-3"><label for="companiesSelected">ТС привязано к компаниям:</label></div>
                        <div class="row pl-2 py-2" v-for="(company, c_index) in editedItem.companies" :key="company.id">
                            <div class="col-11">- {{ company.name }} ({{ company.inn }})</div>
                            <div class="col-1">
                                <b-button
                                    size="sm"
                                    class="ml-2 mt3px"
                                    variant="danger"
                                    title="Отвязать компанию"
                                    @click="deleteCompanyFromList(c_index)"
                                ><b-icon icon="x" font-scale="1.2"></b-icon></b-button>
                            </div>
                        </div>
                    </template>
                </div>
                <form class="needs-validation mb-1 mt-4" novalidate id="truckForm">
                    <h5 class="my-4">Основная информация</h5>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="reference_truck_type_id">Вид ТС</label>
                            <tsoft-select-of-properties
                                :reference_id="42"
                                :needNullElement="false"
                                :needMultipleSelect="false"
                                :defaultSelectName="`Вид ТС`"
                                :internalSearch="false"
                                :selected="editedItem.reference_truck_type_id"
                                @set="setOfTruckType"
                            ></tsoft-select-of-properties>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="reference_truck_body_type_id">Тип кузова ТС</label>
                            <tsoft-select-of-properties
                                :reference_id="43"
                                :needNullElement="false"
                                :needMultipleSelect="false"
                                :defaultSelectName="`Тип кузова`"
                                :internalSearch="false"
                                :selected="editedItem.reference_truck_body_type_id"
                                @set="setOfTruckBodyType"
                            ></tsoft-select-of-properties>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for="number">Гос. номер</label>
                            <input v-model="editedItem.number" @keyup="validGosNumber($event)" type="text" required class="form-control" id="number">
                            <small>Например, А000АА777 или АА0000777</small>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="brand">Марка</label>
                            <input v-model="editedItem.brand" type="text" required class="form-control" id="brand">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="year">Год выпуска</label>
                            <input v-model="editedItem.year" type="number" class="form-control" id="year">
                        </div>
                    </div>

                    <h5 class="my-4">СТС</h5>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="ctc_number">Серия, номер</label>
                            <input required v-model="editedItem.ctc_number" @keyup="filterTSNames($event)" type="text" class="form-control" id="ctc_number">
                            <small>Например, 35ХН503585</small>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="new_ctc_file_face">Фото лицевой стороны</label>
                            <b-form-file
                                v-model="editedItem.new_ctc_file_face"
                                :state="Boolean(editedItem.new_ctc_file_face)"
                                placeholder="Выберите файл..."
                                drop-placeholder="Отпускайте файл..."
                            ></b-form-file>
                            <small v-if="editedItem.ctc_file_face && !editedItem.new_ctc_file_face">
                                Документ уже был загружен, <a :href="hfs+editedItem.ctc_file_face.path" target="_blank">посмотреть &raquo;</a>
                            </small>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="new_ctc_file_back">Фото оборотной стороны</label>
                            <b-form-file
                                v-model="editedItem.new_ctc_file_back"
                                :state="Boolean(editedItem.new_ctc_file_back)"
                                placeholder="Выберите файл..."
                                drop-placeholder="Отпускайте файл..."
                            ></b-form-file>
                            <small v-if="editedItem.ctc_file_back && !editedItem.new_ctc_file_back">
                                Документ уже был загружен, <a :href="hfs+editedItem.ctc_file_back.path" target="_blank">посмотреть &raquo;</a>
                            </small>
                        </div>
                    </div>

                    <h5 class="my-4">ПТС</h5>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="ptc_number">Серия, номер</label>
                            <input required v-model="editedItem.ptc_number" type="text" @keyup="filterTSNames($event)" class="form-control" id="ptc_number">
                            <small>Например, 77ТК123456</small>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="new_ptc_file_face">Фото лицевой стороны</label>
                            <b-form-file
                                v-model="editedItem.new_ptc_file_face"
                                :state="Boolean(editedItem.new_ptc_file_face)"
                                placeholder="Выберите файл..."
                                drop-placeholder="Отпускайте файл..."
                            ></b-form-file>
                            <small v-if="editedItem.ptc_file_face && !editedItem.new_ptc_file_face">
                                Документ уже был загружен, <a :href="hfs+editedItem.ptc_file_face.path" target="_blank">посмотреть &raquo;</a>
                            </small>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="new_ptc_file_back">Фото оборотной стороны</label>
                            <b-form-file
                                v-model="editedItem.new_ptc_file_back"
                                :state="Boolean(editedItem.new_ptc_file_back)"
                                placeholder="Выберите файл..."
                                drop-placeholder="Отпускайте файл..."
                            ></b-form-file>
                            <small v-if="editedItem.ptc_file_back && !editedItem.new_ptc_file_back">
                                Документ уже был загружен, <a :href="hfs+editedItem.ptc_file_back.path" target="_blank">посмотреть &raquo;</a>
                            </small>
                        </div>
                    </div>

                    <h5 class="my-4">Габариты</h5>
                    <div class="form-row">
                        <div class="form-group col-md-3">
                            <label for="dimensions_length">Длина, метры</label>
                            <input v-model="editedItem.dimensions_length" @input='changeTruckV3' type="text" @keyup="changeCommasOnDots($event)" required class="form-control" id="dimensions_length">
                        </div>
                        <div class="form-group col-md-3">
                            <label for="dimensions_width">Ширина, метры</label>
                            <input v-model="editedItem.dimensions_width" @input='changeTruckV3' type="text" @keyup="changeCommasOnDots($event)" required class="form-control" id="dimensions_width">
                        </div>
                        <div class="form-group col-md-3">
                            <label for="dimensions_height">Высота, метры</label>
                            <input v-model="editedItem.dimensions_height" @input='changeTruckV3' type="text" @keyup="changeCommasOnDots($event)" required class="form-control" id="dimensions_height">
                        </div>
                        <div class="form-group col-md-3">
                            <label for="dimensions_volume">Объем кузова, м<sup>3</sup></label>
                            <input v-model="editedItem.dimensions_volume" type="text" @keyup="changeCommasOnDots($event)" required class="form-control" id="dimensions_volume">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-3">
                            <label for="carrying">Грузоподъемность, т.</label>
                            <input v-model="editedItem.carrying" @keyup="changeCommasOnDots($event)" type="text" required class="form-control" id="carrying">
                        </div>
                        <div class="form-group col-md-3">
                            <label for="type_of_loading">Тип погрузки</label>
                            <b-form-select v-model="editedItem.type_of_loading"  size="sm" :options="typeOfTCLoadingList"></b-form-select>
                        </div>
                    </div>

                    <h5 class="my-4">Собственность</h5>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <b-form-checkbox v-model="editedItem.owner" name="check-button" switch class="mr-4">
                                <b>ТС в собственности</b>
                            </b-form-checkbox>
                        </div>
                    </div>
                    <div class="form-row" v-if="editedItem.owner == 0">
                        <div class="form-group col-md-6">
                            <label for="rent_number">Договор аренды. Номер и дата</label>
                            <input v-model="editedItem.rent_number" type="text" class="form-control" id="rent_number">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="new_rent_file">Скан договора</label>
                            <b-form-file
                                v-model="editedItem.new_rent_file"
                                :state="Boolean(editedItem.new_rent_file)"
                                placeholder="Выберите файл..."
                                drop-placeholder="Отпускайте файл..."
                            ></b-form-file>
                            <small v-if="editedItem.rent_file && !editedItem.new_rent_file">
                                Документ уже был загружен, <a :href="hfs+editedItem.rent_file.path" target="_blank">посмотреть &raquo;</a>
                            </small>
                        </div>
                    </div>

                    <h5 class="my-4">Проверка ТС</h5>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="checked_id">Статус проверки</label>
                            <tsoft-select-of-properties
                                :reference_id="44"
                                :needNullElement="false"
                                :needMultipleSelect="false"
                                :defaultSelectName="`Статус проверки`"
                                :internalSearch="false"
                                :selected="editedItem.checked_id"
                                @set="setStatusOfChecking"
                            ></tsoft-select-of-properties>
                        </div>
                    </div>

                </form>
            </div>
            <!-- control tabs button -->
            <template #footer>
                <div class="row">
                    <div class="col-9">

                    </div>
                    <div class="col-3 text-right">
                        <button  class="btn btn-outline-primary" @click="submitForm($event)">Сохранить<i class="fas fa-spinner fa-spin ml-1" v-if="savingProcess"></i></button>
                    </div>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
    import { API_TRUCKS, HOST_FOR_STORAGE } from "../../constants"
    import debounce from '../../services/helpers'

    import {
        typeOfCompany,
        maxCharsLimit,
        defaultDataItems,
        buildFormData,
        typeOfTCLoadingList,
        changeCommasOnDots,
        filterTSNames,
        validGosNumber
    } from '../../mixins'

    export default {
        props: {
            isSideBarOpenDriver: { type: Boolean, required: false },
            editIndex: { type: Number || String, required: false, default: -1 },
            editedItemExt: { type: Object, required: false }
        },
        mixins: [
            typeOfCompany,
            maxCharsLimit,
            defaultDataItems,
            buildFormData,
            typeOfTCLoadingList,
            changeCommasOnDots,
            filterTSNames,
            validGosNumber
        ],
        data() {
            return {
                tableApiUrl: API_TRUCKS,
                savingProcess: false,
                hfs: HOST_FOR_STORAGE,
                selectedCompanyId: '',
                selectedCompany: {},
            }
        },
        watch: {
            'editedItemExt': function (editedItem){
                this.onItemEditModalCallback()
            },
        },
        computed: {
            isSideBarOpenDriverLocal: {
                get: function() {
                    return this.isSideBarOpenDriver
                },
                set: function(value) {
                    this.$emit('update:isSideBarOpenDriver', value)
                }
            },
            editedItem: {
                get: function() {
                    return this.editedItemExt
                },
                set: function(value) {
                    this.$emit('update:editedItemExt', value)
                }
            }
        },
        mounted() {
        },
        methods: {
            submitForm(event) {
                event.preventDefault()
                let form = document.getElementById("truckForm")
                if (form.checkValidity() === false) {
                    event.preventDefault()
                    event.stopPropagation()
                    form.classList.add('was-validated')
                    return false
                }
                this.createOrUpdateItem()
            },
            createOrUpdateItem() {
                this.savingProcess = true
                if (typeof this.onCreateOrUpdateItemCallback === 'function') {
                    this.onCreateOrUpdateItemCallback()
                }

                this.editedItem.owner = this.editedItem.owner == false ? 0 : 1

                const formData = new FormData()
                this.buildFormData(formData, this.editedItem)

                if (this.editIndex == -1) {
                    api.call("post", this.tableApiUrl, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }).then(({data}) => {
                        this.$emit('create', data)
                        this.savingProcess = false
                        this.isSideBarOpenDriverLocal = false
                        this.makeToast('success', 'ТС добавлено')
                    }).catch((response) => {

                    })
                } else {
                    formData.append('_method', 'PUT')

                    api.call("post", `${this.tableApiUrl}/${this.editedItem.id}`, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }).then(({data}) => {
                        this.$emit('update', data)
                        this.savingProcess = false
                        this.isSideBarOpenDriverLocal = false
                        this.makeToast('info', 'Изменения в карточке ТС сохранены')
                    }).catch((response) => {

                    })
                }
            },
            // calls from mixin on item edit
            onItemEditModalCallback() {
                this.selectedCompanyId = ''
                this.cleanCompanyInfo()
                this.editedItem.owner = this.editedItem.owner == 0 ? false : true

                this.maskPhone = this.editedItem.phone
                this.maskAdditionalPhone = this.editedItem.phone_additional
            },
            // calls from mixin on item save
            onCreateOrUpdateItemCallback() {
            },
            closeSidePanelCallback() {
                this.$emit('closeSidePanel')
            },
            addCompanyToList() {
                this.editedItem.companies.unshift({
                    id: this.selectedCompany.id,
                    name: this.selectedCompany.name,
                    inn: this.selectedCompany.inn,
                })
                this.selectedCompanyId = ''
                this.cleanCompanyInfo()
            },
            deleteCompanyFromList(index) {
                this.editedItem.companies.splice(index, 1)
            },
            cleanCompanyInfo() {
                for (const prop of Object.getOwnPropertyNames(this.selectedCompany)) {
                    delete this.selectedCompany[prop]
                }
            },
            setCompanyOfTruck(id, selectedCompany) {
                if (selectedCompany != null && selectedCompany.id) {
                    this.selectedCompanyId = id
                    this.selectedCompany = { ...selectedCompany }
                }
            },
            setStatusOfChecking(value) {
                this.editedItem.checked_id = value
            },
            setOfTruckType(value) {
                this.editedItem.reference_truck_type_id = value
            },
            setOfTruckBodyType(value) {
                this.editedItem.reference_truck_body_type_id = value
            },
            changeTruckV3() {
                this.editedItem.dimensions_volume =
                    this.editedItem.dimensions_length *
                    this.editedItem.dimensions_width *
                    this.editedItem.dimensions_height
                this.editedItem.dimensions_volume = Math.floor(this.editedItem.dimensions_volume)
            },
        }
    }
</script>
<style scoped>
    .big-add-button {
        height: 50px;
    }
    .custom-select {
        line-height: 32px;
        height: 50px;
        border-radius: 1px;
    }
</style>
